<template>
  <div class="view view--settings">
    <div class="elapsedtime">Total: {{ sec2time(elapsedTime) }} / {{ sec2time(totalTime) }}</div>
    <div class="clock" @click="pauseTimer">
      <div class="clock__contentwrapper">
        <div class="clock__content">
          <h1 class="clock__title">{{ currentTitle }}</h1>
          <div class="clock__remaining">{{ currentDisplayTime }}</div>
          <h2
            class="clock__title clock__title--sub"
            :html="currentSubTitle">
          </h2>
        </div>
      </div>
      <div class="clock__circles">
        <div class="clock__circle clock__circle--total">
          <ArcCounter size="90%"
            :start="0"
            :end="359.99"
            dashCount="360"
            :activeCount="currentTimeDegree"
            strokeWidth="3"
            activeWidth="3"
            stroke="rgba(255,255,255,.3)"
            activeStroke="white"
            dashSpacing="0"
            >
          </ArcCounter>
        </div>
    </div>
    </div>
    <router-link
        class="backbutton"
        to="/" @click="stopCountdown">
        <img class="icon icon--back" src="/static/img/back.svg" alt="zurück">
    </router-link>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import ArcCounter from '@/components/arccounter.vue';

export default {
  name: 'timer',
  components: {
    ArcCounter,
  },
  data: () => ({
    currentStep: 0,
    totalTimers: false,
    totalTime: 0,
    timerActive: true,
    currentRound: 1,
    currentWorkout: [],
    currentTime: 0,
    currentDisplayTime: 0,
    tick: null,
    elapsedTime: 0,
    elapsedTimeMilliseconds: 0,
  }),
  computed: {
    ...mapGetters([
      'settingsActive',
      'currentTimer',
      'timerSettings',
    ]),
    currentTitle() {
      return this.currentWorkout[this.currentStep].title;
    },
    currentSubTitle() {
      const sub = this.currentWorkout[this.currentStep].subtitle;
      return sub === '' ? '&nbsp;' : sub;
    },
    currentTimeDegree() {
      return (this.elapsedTimeMilliseconds / this.totalTime) * 0.36;
    },
  },
  methods: {
    pauseTimer() {
      if (this.timerActive) {
        clearInterval(this.tick);
        this.timerActive = false;
      } else {
        this.startTimer();
        this.timerActive = true;
      }
    },
    startTimer() {
      clearInterval(this.tick);
      this.tick = setInterval(() => {
        this.elapsedTime = this.currentTime % 1000 === 0 || this.currentTime === 0
          ? this.elapsedTime += 1
          : this.elapsedTime;
        this.currentTime -= 100;
        this.elapsedTimeMilliseconds += 100;
      }, 100);
    },
    stopCountdown() {
      clearInterval(this.tick);
    },
    playBeep() {
      this.$emit('playBeep');
    },
    makeAnnouncement(prefix, title) {
      const announcement = {
        prefix,
        title,
      };
      this.$emit('makeAnnouncement', announcement);
    },
  },
  created() {
    this.totalTime += 10;
    this.currentWorkout.push({
      name: 'countdown',
      title: 'Get ready',
      type: 'splash',
      value: 10,
      subtitle: '',
    });
    // let repeat = 0;
    // console.log(this.$refs);
    if (this.currentTimer.warmup > 0) {
      this.currentWorkout.push({
        name: 'warmup',
        title: this.timerSettings.warmup.title,
        speak: 'warm up',
        type: 'simple',
        value: this.currentTimer.warmup,
        subtitle: '',
      });
      this.totalTime += this.currentTimer.warmup;
    }
    for (let round = 0; round < this.currentTimer.rounds; round += 1) {
      for (let interval = 0; interval < this.currentTimer.exercises; interval += 1) {
        this.currentWorkout.push({
          name: 'exercise',
          title: `Exercise ${interval + 1} / ${this.currentTimer.exercises}`,
          subtitle: `Round ${round + 1} / ${this.currentTimer.rounds}`,
          speak: `Exercise: ${interval + 1}`,
          type: 'full',
          value: this.currentTimer.intervals,
          round,
          interval,
        });
        this.totalTime += this.currentTimer.intervals;
        this.currentWorkout.push({
          name: 'break',
          title: `Break / Low Intensity ${interval + 1}`,
          subtitle: `Round ${round + 1} / ${this.currentTimer.rounds}`,
          speak: 'Break: Low Intensity',
          type: 'full',
          value: this.currentTimer.breaks,
          round,
          interval,
        });
        this.totalTime += this.currentTimer.breaks;
      }
    }
    if (this.currentTimer.stretching > 0) {
      this.currentWorkout.push({
        name: 'stretching',
        speak: 'stretching',
        subtitle: '',
        title: this.timerSettings.stretching.title,
        type: 'simple',
        value: this.currentTimer.stretching,
      });
      this.totalTime += this.currentTimer.stretching;
    }
    this.totalTimers = this.currentWorkout.length;
    this.currentTime = this.currentWorkout[0].value * 1000;
  },
  mounted() {
    this.startTimer();
  },
  watch: {
    currentTime() {
      const beepers = [3000, 2000, 1000];
      if (beepers.includes(this.currentTime)) {
        // this.playBeep();
        const toSpeak = (this.currentTime / 1000).toString();
        this.makeAnnouncement('', toSpeak);
      }
      if (this.currentTime % 1000 === 0) {
        this.currentDisplayTime = this.sec2time(this.currentTime / 1000);
      }
      if (this.currentTime === 8000 && this.currentStep + 1 < this.totalTimers) {
        const toSpeak = this.currentWorkout[this.currentStep + 1].speak
          ? this.currentWorkout[this.currentStep + 1].speak
          : this.currentWorkout[this.currentStep + 1].title;
        this.makeAnnouncement('next: ', toSpeak);
      }
      if (this.currentTime === 0) {
        clearInterval(this.tick);
        if (this.currentStep + 1 < this.totalTimers) {
          this.currentStep += 1;
          const toSpeak = this.currentWorkout[this.currentStep].speak
            ? this.currentWorkout[this.currentStep].speak
            : this.currentWorkout[this.currentStep].title;
          this.makeAnnouncement('Start: ', toSpeak);
          this.currentTime = this.currentWorkout[this.currentStep].value * 1000;
          this.$nextTick(() => {
            this.startTimer();
          });
        } else {
          this.makeAnnouncement('You made it!', 'Awesome: Congratulations!');
        }
      }
    },
  },
};

</script>
<style lang="stylus">
@import '~styles/variables.styl'

.backbutton
  text-decoration none
  color weiss
  display inline-block
  position absolute
  top unquote('max(1rem, env(safe-area-inset-top))')
  left 1rem
.elapsedtime
  font-size 12px
  text-transform uppercase
  padding .5rem
  color #c0c0c0
.clock
  width 98%
  max-width 360px
  margin 0 auto
  position relative
  top 10vh
  &__title
    font-size 16px
    color white
    text-transform uppercase
    padding 4rem 0 0
    &--sub
      padding 0 0 4rem
  &__remaining
    font-size 100px
    font-weight 500
    padding 1rem 0
    color white
    font-family 'Fira Mono', monospace
    letter-spacing -10px
  &__contentwrapper, &__circles
    position absolute
    left 0
    width 100%
  &__contentwrapper
    padding-bottom 90%
  &__content
    position absolute
    left 0
    top 0
    bottom 0
    right 0
    display flex
    flex-direction column
    justify-content space-around
.icon
  fill: white
  width 24px
  height 24px
.button
  &--pause
    color white
    border none
    font-family 'Fira Sans'
    font-size 16px
    background none

</style>
